export default __webpack_public_path__ + "static/media/logo-starken.bdef6196.png";